import React from 'react';
import { CheckCircle2, Clock, XCircle, Circle, Ban } from 'lucide-react';
import { ModuleProgress } from '../../services/trainingApi';

interface ModuleCardProps {
  progress: ModuleProgress;
  onClick?: () => void;
}

const STATUS_META: Record<
  ModuleProgress['status'],
  { label: string; Icon: React.ComponentType<{ className?: string }>; classes: string }
> = {
  aprobado: {
    label: 'Aprobado',
    Icon: CheckCircle2,
    classes: 'border-green-500/40 bg-green-500/10 text-green-400',
  },
  reprobado: {
    label: 'Reprobado',
    Icon: XCircle,
    classes: 'border-red-500/40 bg-red-500/10 text-red-400',
  },
  en_progreso: {
    label: 'En progreso',
    Icon: Clock,
    classes: 'border-ngs-cyan/40 bg-ngs-cyan/10 text-ngs-cyan',
  },
  pendiente: {
    label: 'Pendiente',
    Icon: Circle,
    classes: 'border-gray-500/40 bg-gray-500/10 text-gray-300',
  },
};

export default function ModuleCard({ progress, onClick }: ModuleCardProps) {
  const meta = STATUS_META[progress.status];
  const Icon = meta.Icon;
  const bloqueadoPorRol = !progress.aplicable_al_rol;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={bloqueadoPorRol}
      className={`group relative text-left w-full rounded-xl border p-5 transition-all ${
        bloqueadoPorRol
          ? 'border-gray-700 bg-ngs-surface opacity-50 cursor-not-allowed'
          : 'border-ngs-cyan/20 bg-ngs-surface hover:border-ngs-cyan/60 hover:shadow-lg hover:shadow-ngs-cyan/10'
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-ngs-cyan/15 text-ngs-cyan font-bold text-sm">
            {progress.modulo.orden}
          </span>
          <h3 className="text-base font-semibold text-white group-hover:text-ngs-cyan transition-colors">
            {progress.modulo.nombre}
          </h3>
        </div>
        {bloqueadoPorRol ? (
          <span className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border border-gray-700 text-gray-400">
            <Ban className="h-3 w-3" />
            No aplica
          </span>
        ) : (
          <span
            className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border ${meta.classes}`}
          >
            <Icon className="h-3 w-3" />
            {meta.label}
          </span>
        )}
      </div>

      <p className="text-sm text-gray-400 line-clamp-2 mb-3">
        {progress.modulo.descripcion}
      </p>

      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>
          Umbral: <b className="text-gray-300">{progress.modulo.umbral_aprobacion}%</b>
        </span>
        {progress.mejor_puntaje !== null && (
          <span>
            Mejor puntaje: <b className="text-gray-300">{progress.mejor_puntaje}%</b>
          </span>
        )}
      </div>
    </button>
  );
}
